<!-- Author: Wilson Pilco Nunez -->
<!-- Email: wilsonaux1@gmail.com -->
<!-- Created at: 2021-08-06 19:20 -->
<template>
  <div class="mb-3">
    <label for="">Justificacion de cambio de precio</label>
    <div class="input-group">
      <input
        type="text"
        aria-label="Nombre"
        v-model="name"
        placeholder="Nombre"
        class="form-control"
        style="max-width: 170px"
      />
      <input
        type="text"
        aria-label="Justificacion"
        v-model="justification"
        placeholder="Justificacion"
        class="form-control"
      />
    </div>
    <app-form-errors :member="errors.name"></app-form-errors>
    <app-form-errors :member="errors.justification"></app-form-errors>
    <!-- <select v-model="price_change_justification" class="custom-select"> -->
    <!--   <option value=""></option> -->
    <!--   <option value=""></option> -->
    <!-- </select> -->
  </div>
</template>
<script>
import validator from "src/utils/validator";
const formRules = {
  name: {
    presence: {
      allowEmpty: false,
      message: "Pon tu nombre"
    }
  },
  justification: {
    presence: {
      allowEmpty: false,
      message: "Requieres especificar una justificacion por el cambio de precio"
    }
  }
};
export default {
  components: {
    //
  },

  // directives
  // filters

  props: {
    //
  },

  data: () => ({
    name: null,
    justification: null
  }),

  computed: {
    errors() {
      return validator(this.$data, formRules, { fullMessages: false });
    }
  },

  // watch: {},

  mounted() {
    //
  },

  methods: {
    isValid() {
      return this.errors === false;
    },
    reset() {
      this.name = null;
      this.justification = null;
    }
  }
};
</script>

<style scoped></style>
